<template>
  <div class="shippingAddress">
    <div class="flex" v-if="!isNone">
      <div class="overflow">
        <van-swipe-cell v-for="item in addressAll" :key="item.id">
          <van-cell :border="false">
            <div class="information">
              <div class="peopleInformation">
                <div
                  class="addressPhone"
                  style="padding: 0 0.18rem 0.18rem 0"
                  @click="goback(item)"
                >
                  <p class="address">
                    {{ item.province + item.city + item.area + item.add }}
                  </p>
                  <p class="phoneAndName">{{ item.phone + " " + item.name }}</p>
                </div>
                <div class="edit">
                  <img
                    @click="
                      $router.replace({
                        name: '编辑地址',
                        params: { item: item },
                      })
                    "
                    src="../../assets/img/address/adress_btn_edit@2x.png"
                    alt=""
                    style="width: 0.12rem; height: 0.12rem"
                  />
                </div>
              </div>
              <div>
                <div class="line"></div>
                <div class="bottom">
                  <van-radio-group v-model="radio">
                    <van-radio
                      name="1"
                      style="font-size: 0.12rem; line-height: 0.2rem"
                    >
                      默认地址
                      <template #icon="props">
                        <img
                          class="img-icon"
                          :src="item.default == '1' ? activeIcon : inactiveIcon"
                          @click="changeDefault(item.id, item.default)"
                          style="width: 0.12rem; height: 0.12rem"
                        />
                      </template>
                    </van-radio>
                  </van-radio-group>
                </div>
              </div>
            </div>
          </van-cell>
          <template #right>
            <van-button
              square
              type="danger"
              @click="deleteAddess(item.id)"
              text="删除"
            />
          </template>
        </van-swipe-cell>
      </div>
    </div>
    <!-- 当没有收货地址时 -->
    <div
      v-if="isNone"
      class="noAddress"
      style="
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #f3f1f4;
      "
    >
      <img
        src="../../assets/img/empty/img_blank_adress@2x.png"
        alt=""
        style="width: 2.17rem; height: 1.75rem; margin-top: 1.75rem"
      />
      <p
        style="
          height: 0.24rem;
          font-size: 0.12rem;
          color: #99999b;
          line-height: 0.24rem;
        "
      >
        暂无收货地址~
      </p>
    </div>
    <div class="buttonBox">
      <van-button
        class="addAddressBtn"
        @click="
          $router.replace({
            name: '添加地址',
            params: { isHas: addressAll.length },
          })
        "
        >添加新地址</van-button
      >
    </div>
  </div>
</template>

<script>
import { addressList, addressDefault, removeAddress } from '@/api/home.js'
export default {
  data () {
    return {
      isNone: false,
      loading: null,
      radio: '1',
      addressAll: [],
      activeIcon: require('../../assets/img/address/icon_select_adress_pre@2x.png'),
      inactiveIcon: require('../../assets/img/address/icon_select_adress@2x.png')
    }
  },
  created () {
    this.isLoading(true)
    addressList()
      .then((res) => {
        this.isLoading(false)
        if (res.data.backdata.address.length == 0) {
          this.isNone = true
        } else {
          this.addressAll = res.data.backdata.address
          this.isNone = false
        }
      })
      .catch((err) => {
        console.log(err)
        this.isLoading(false)
      })
  },
  beforeRouteEnter (to, from, next) {
    if (
      from.name == '确认订单' ||
      from.name == '个人中心' ||
      from.name == '提货到线下'
    ) {
      sessionStorage.setItem('addressParams', from.path)
    }
    next()
  },
  methods: {
    goback (val) {
      if (sessionStorage.getItem('addressParams') !== '/personal') {
        sessionStorage.setItem('backAddress', JSON.stringify(val))
        this.$router.replace(sessionStorage.getItem('addressParams'))
      }
    },
    isLoading (val) {
      if (val) {
        this.loading = this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: 0
        })
      } else {
        this.loading.clear()
      }
    },
    deleteAddess (id) {
      removeAddress({ id: id }).then((res) => {
        this.$toast(res.data.msg)
        if (res.data.code == 0) {
          addressList().then((res) => {
            if (res.data.backdata.address.length == 0) {
              this.isNone = true
              this.addressAll = []
            } else {
              this.addressAll = res.data.backdata.address
              this.isNone = false
            }
            this.$forceUpdate()
          })
        }
      })
    },
    changeDefault (id, def) {
      const defau = def == '0' ? '1' : '0'
      addressDefault({ id: id, default: defau }).then((res) => {
        if (res.data.code == 0) {
          addressList().then((res) => {
            this.addressAll = res.data.backdata.address
          })
        }
        this.$toast(res.data.msg)
      })
    }
  }
}
</script>

<style lang='scss'>
.img-icon {
  width: 0.12rem;
  height: 0.12rem;
}
.shippingAddress {
  width: 100%;
  height: 100%;
  background: #f3f1f4;
  padding: 0.68rem 0 0.22rem 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  .van-swipe-cell {
    margin: 0.11rem 0.14rem 0 0.15rem;
    width: 3.45rem;
    // height: 1.23rem;

    border-radius: 8px;
    .van-swipe-cell__wrapper {
      transform: translate3d(0px, 0px, 0px);
      //   transform: translate3d(-50px, 0px, 0px);
      .van-cell--borderless {
        padding: 0;
        .van-cell__value {
          .information {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            width: 3.45rem;
            // height: 1.23rem;

            padding: 0.14rem 0.15rem 0rem 0.15rem;

            .peopleInformation {
              display: flex;
              justify-content: space-between;
              width: 100%;
              .address {
                width: 2.66rem;
                font-size: 0.14rem;
                font-weight: bold;
                color: #343434;
                line-height: 0.18rem;
                margin-bottom: 0.06rem;
              }
              .phoneAndName {
                font-size: 0.12rem;
                color: #343434;
              }
              img {
                margin-top: 0.2rem;
              }
            }
            .line {
              margin: 0.09rem 0 0;
              width: 3.15rem;
              height: 0.01rem;
              background: #f3f1f3;
            }
            .bottom {
              height: 0.36rem;
              .van-radio {
                height: 0.36rem;
                .van-radio__icon {
                  height: 0.12rem;
                  width: 0.12rem;
                }
                .van-radio__label {
                  margin-left: 0.06rem;
                }
              }
            }
          }
        }
      }
      .van-swipe-cell__right {
        .van-button--danger {
          width: 0.49rem;
          height: 100%;
          background: #ff5d5d;
          border-radius: 0px 0.08rem 0.08rem 0px;
        }
      }
    }
  }
  .overflow {
    margin-bottom: 0.8rem;
  }
  .buttonBox {
    width: 100%;
    height: 0.88rem;
    position: fixed;
    bottom: 0;
    background-color: #f3f1f4;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .addAddressBtn {
    width: 2.62rem;
    height: 0.44rem;
    border: none;
    background: linear-gradient(0deg, #d1ae79 0%, #f0d8b1 100%);
    border-radius: 0.22rem;
    font-size: 0.16rem;
    font-weight: bold;
    color: #93673d;
  }
}
</style>
